import { render, staticRenderFns } from "./MemberCreate.vue?vue&type=template&id=058e81a8"
import script from "./MemberCreate.vue?vue&type=script&lang=js"
export * from "./MemberCreate.vue?vue&type=script&lang=js"
import style0 from "./MemberCreate.vue?vue&type=style&index=0&id=058e81a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports